export class SignUpQualifier {

  constructor(data, local) {

    this.d1 = data.businessName || '';
    this.d3 = data.rfc || undefined;
    this.d4 = data.tin || undefined;
    this.d6 = data.names || '';
    this.d7 = data.firstSurname || '';
    this.d8 = data.secondSurname;
    this.d9 = data.position || '';
    this.d10 = {
      d1: data.mobilePhoneCcc.code || undefined
    };
    this.d11 = local ? data.mobilePhone :  data.foreignmobilePhone || '';
    this.d12 = local ? data.landLine : data.foreignlandLine || '';
    this.d13 = data.email || '';
    this.d14 = data.lang || 'ES';
    this.d2 = {
      d1: (data.origin && data.origin.code) || undefined
    };
    this.d5 = (!data.legalEntity || !data.legalEntity.code) ? undefined : {
      d1: data.legalEntity.code
    };
    this.monterrey = data.monterrey
    this.productsOrServices = data.productsOrServices
  }
}